import { SwitchProps } from '@mui/material';

import { StyledSwitch } from '@/shared/ui/Switch/styles';

type TSwitch = SwitchProps;

export const Switch = (props: TSwitch) => {
  return <StyledSwitch disableFocusRipple {...props} />;
};
